export enum BulkUploadStatus {
  TRANSFERRING ='TRANSFERRING', // createDateTime
  VIRUS_SCAN_QUEUED = 'VIRUS_SCAN_QUEUED', // lastUpdateDateTime
  SCANNING = 'SCANNING', // lastUpdateDateTime
  QUEUED = 'QUEUED', // lastUpdateDateTime
  IN_PROGRESS = 'IN_PROGRESS', // startDateTime (ignore lastUpdateDateTime)
  SUCCESS = 'SUCCESS', // endDateTime
  FAILED = 'FAILED', // endDateTime
}
